import { request } from './axios.config';

export const article = {
    async getArticle(id: number | string): Promise<IArticle> {
        return request.get<IArticle>('/emailtemplate/get', {
            params: {
                id: id
            },
        });
    },

    async updateArticle(
        id: number,
        options: {
            subject: string;
            subtitle: string;
            json: string;
            mjml: string;
            html: string;
            previewImage: string;
        }
    ): Promise<IArticle> {
        return request.post<IArticle>('/emailtemplate/edit', {
            ...options,
            id: id
        });
    }
};

export interface ListResponse<T> {
    list: T[];
    count: number;
}

export interface IArticle {
    id: number;
    subject: string;
    subTitle: string;
    json: string;
    mjml: string;
    html: string;
    datecreated: string;
    previewimage: string;

}
